import React from 'react';
import '../styles/login.css';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { pagesContent } from '../redux/profilService';
import { useState } from 'react';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import ErrorPopup from '../components/ErrorPopup';
import LOGO from '../assets/img/neo_bulle_bandeau.png';
import { NavLink, useNavigate } from 'react-router-dom';
import { PoliceDefaut } from '../helpers/contants';
import { LinearProgress } from '@mui/material';
import APPSTORE from '../assets/img/Bouton__App Store.png';
import GOOGLEPLAY from '../assets/img/Bouton__Google Play.png';
import textConnect from '../textConnect.json';
import axios from 'axios';

const Principale = () => {
  const dispatch = useDispatch();
  const contenusBO = useSelector(state => state.profil.contenusTexte);
  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');
  const closeErrorHandle = () => {
    setOpenError(false);
  };

  const [loader, setLoader] = useState(true);
  const [events, setEvents] = useState([]);

  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  const fetchEvents = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/evenements/actifs`);
      console.log('events', data);
      setEvents(data);
    } catch (error) {
      console.log('error occured on fetching events', error);
    }
  };

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, []);

  useEffect(() => {
    pagesContent()
      .then(reponse => {
        dispatch({
          type: 'Profil/addTextContent',
          payload: reponse.data,
        });
        setLoader(false);
      })
      .catch(erreur => {
        // setLoader(false)
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }

        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  }, [dispatch, netStatus]);

  useEffect(() => {
    (async () => await fetchEvents())();
  }, []);

  const navigate = useNavigate();
  const showLoader = useDelayedLoading(loader, 250);
  return (
    <>
      {showLoader ? (
        <div
          className="d-flex flex-column align-items-center justify-content-center min-vh-100"
          style={{ backgroundColor: '#134491', gap: '1rem' }}
        >
          <img
            src={LOGO}
            alt="NEO"
            style={{ width: 150, height: 'auto', maxHeight: 120, objectFit: 'contain' }}
          />
          <LinearProgress sx={{ width: '200px', marginTop: 1 }} />
          <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />
        </div>
      ) : loader ? (
        <div className="min-vh-100" style={{ backgroundColor: '#134491' }} />
      ) : (
        <Container
          fluid
          className="d-flex align-items-stretch justify-content-center login login-page-viewport"
          style={{ position: '', height: '100dvh', maxHeight: '100dvh' }}
        >
          <video
            id="login-video"
            className="video-login "
            src={contenusBO !== undefined ? contenusBO.fichier : ''}
            preload="auto"
            muted
            type="video/mp4"
            autoPlay={true}
            loop={true}
            playsInline
            poster=""
          >
            impossible de lire la vidéo
          </video>

          <Row
            className="d-flex flex-column align-items-center flex-grow-1"
            style={{ margin: 0, minHeight: 0, width: '100%', maxWidth: '90vw', flex: '1 1 0' }}
          >
            <div
              className="principale-content d-flex flex-column justify-content-start justify-content-md-center"
              style={{
                zIndex: '600',
                width: '100%',
                flex: '1 1 auto',
                minHeight: 0,
                overflowY: 'auto',
              }}
            >
              <Container>
                <Row
                  className="logo-logind "
                  style={{ margin: 'auto', maxWidth: 550, marginTop: 'clamp(1rem, 4vh, 10%)' }}
                >
                  <img src={LOGO} alt="NEO" className="" style={{ zIndex: '600' }} />
                </Row>

                <Row className="text-login text-center m-auto my-2" style={{ border: 'none' }}>
                  {/* {texteIntro === undefined ? (
                    <></>
                  ) : (
                    <p
                      className="p-0"
                      dangerouslySetInnerHTML={{
                        __html: texteIntro,
                      }}
                    />
                  )} */}
                </Row>

                {/* <Row className=" mt-5">
                  <Col
                    className="texte-choix-evt"
                    style={{
                      textAlign: "center",
                      fontSize: "1.5rem",
                      color: "#e84d14",
                    }}
                  >
                    Téléchargez NEO, l’assistant virtuel des Universités des
                    Mairies
                  </Col>
                </Row> */}
                <Row className="my-4" style={{ margin: 'auto', width: 'fit-content' }}>
                  <Col
                    onClick={() =>
                      window.open('https://apps.apple.com/us/app/bec-neo/id6450933172', '_blank')
                    }
                    className="d-flex justify-content-center p-0"
                    style={{ width: 'fit-content' }}
                  >
                    <img
                      className=""
                      style={{ width: '270px', cursor: 'pointer' }}
                      src={APPSTORE}
                      alt=""
                    />
                  </Col>

                  <Col
                    onClick={() =>
                      window.open(
                        'https://play.google.com/store/apps/details?id=com.neo_bec',
                        '_blank'
                      )
                    }
                    className="d-flex justify-content-center p-0"
                    style={{ width: 'fit-content' }}
                  >
                    <img style={{ width: '270px', cursor: 'pointer' }} src={GOOGLEPLAY} alt="" />
                  </Col>
                </Row>
                <Row className="my-2">
                  <Col
                    className="d-flex flex-column gap-3 mx-auto"
                    style={{ flex: '0 1 auto', width: 'fit-content' }}
                  >
                    <Button
                      className="py-2"
                      onClick={() => navigate('/login')}
                      style={{
                        borderRadius: '50px',
                        backgroundColor: '#e84d14',
                        borderColor: '#e84d14',
                      }}
                    >
                      Se connecter à mon compte
                    </Button>
                    <Button
                      variant="outline-light"
                      className="guest-access-button"
                      onClick={() => navigate('/companion')}
                    >
                      Connexion invité
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <div className="d-flex justify-content-center align-items-center">
                    <p className="access-wording">
                      L'accès à la plateforme nécessite d'être inscrit. <br /> Pour s'inscrire,
                      cliquez sur la manifestation de votre choix :
                    </p>
                  </div>
                  <div className="logo-container">
                    {events.map(({ url, photo }, index) => {
                      return (
                        <>
                          <a href={url} target="_blanck" style={{ margin: '20px' }} key={index}>
                            <img style={{ width: '200px', cursor: 'pointer' }} src={photo} alt="" />
                          </a>
                        </>
                      );
                    })}
                  </div>
                </Row>
              </Container>
            </div>
            <footer
              className="d-flex align-items-end footer-login"
              style={{ marginTop: 'auto', flexShrink: 0 }}
            >
              <Container>
                <Row>
                  <Col
                    className="mt-4 mb-1"
                    style={{
                      width: '',
                      fontSize: '.75rem',
                      textAlign: 'center',
                      fontFamily: PoliceDefaut,
                      zIndex: '700',
                      color: 'white',
                    }}
                  >
                    &copy; 2026 Agence BEC •{' '}
                    <NavLink
                      className="mentions-legales"
                      style={{ textDecoration: 'none' }}
                      to={'/conditionsLegales/0'}
                    >
                      {' '}
                      Mentions légales
                    </NavLink>{' '}
                    •{' '}
                    <NavLink
                      className="mentions-legales"
                      style={{ textDecoration: 'none' }}
                      to={'/copyright/0'}
                    >
                      Conditions d'utilisation
                    </NavLink>{' '}
                    •{' '}
                    <NavLink
                      className="mentions-legales"
                      style={{ textDecoration: 'none' }}
                      to={'/politiqueConfidentialite/0'}
                    >
                      Politique de confidentialité
                    </NavLink>
                  </Col>
                </Row>
              </Container>
            </footer>
          </Row>
        </Container>
      )}
    </>
  );
};

export default Principale;
